import { transform } from "ol/proj";

import OlStyle from "ol/style/Style";
import OlStroke from "ol/style/Stroke";
import OlCircle from "ol/style/Circle";
import OlFill from "ol/style/Fill";
import OlIcon from "ol/style/Icon";
import OlText from "ol/style/Text";
import OlRegularShape from "ol/style/RegularShape";

import OlGeomMultiPoint from "ol/geom/MultiPoint";
import OlGeomPoint from "ol/geom/Point";
import OlGeomPolygon from "ol/geom/Polygon";
import OlGeomLineString from "ol/geom/LineString";
import { toStringHDMS } from 'ol/coordinate';
import { createStringXY } from 'ol/coordinate';

import { calcAngle, formatArea, formatLength } from "@/lib/olHelpers";
import { CoordinateSystemType } from "@/@types/common";
import { sifrarnici } from "@/lib/sifrarnici";

export {
  drawStyle,
  measurementsStyle,
  measuringStyle,
  recordStyle,
  selectedStyle,
  geoLocateStyle,
  drawingRouteStyle,
  drawRouteStyle,
  routeStyle,
  routePointStyle,
  commentsStyle,
  commentingStyle,
  poiStyle,
  highlightedPoiStyle,
  routePinPointStyle,
  routeDashedLineStyle,
  originalClickPointStyle,
  ktStyle,
  selectedSegmentStyle
};


const recordStyle = () => {
  let style = new OlStyle({
    image: new OlCircle({
      radius: 7,
      stroke: new OlStroke({
        color: "rgba(255, 255, 255, 0.79)"
      }),
      fill: new OlFill({
        color: "rgba(26, 114, 158, 0.79)"
      })
    }),
    fill: new OlFill({
      color: "rgba(184, 184, 184, 0.4)"
    }),
    stroke: new OlStroke({
      color: "#ff1f1f",
      width: 3.25
    })
  });
  return style;
};

const selectedStyle = (f: any) => {
  const tip_id = f.get("poi_tip_id");
  const image_url = "../images/icons/" + definePoiImage(tip_id, 3);

  const poiIcon = tip_id ? new OlIcon({
    src: image_url,
    height: 30,
    width: 30
  })
    : null;



  const pointStyle = new OlStyle({
    image: poiIcon ? poiIcon : new OlCircle({
      radius: 14,
      stroke: new OlStroke({
        color: "rgba(255, 0, 255, 0.8)",
        width: 4
      }),
    }),
    // fill: new OlFill({
    //   color: "rgba(184, 184, 184, 0.4)"
    // }),
    stroke: new OlStroke({
      color: "#FF00FF",
      width: 6
    })
  });



  const lineBackground = new OlStyle({
    stroke: new OlStroke({
      color: "rgba(255,255,255,1)",
      width: 6
    })
  });

  const lineForeground = new OlStyle({
    stroke: new OlStroke({
      color: "rgba(255,0,0,0.8)",
      width: 6,
      lineDash: [10, 10],
    })
  });

  return [pointStyle, lineBackground, lineForeground];
};

const selectedSegmentStyle = (f: any) => {
  const lineStyle = new OlStyle({
    stroke: new OlStroke({
      color: f.get('color') as string,
      width: 9
    })
  });

  return lineStyle
}

const drawStyle = new OlStyle({
  image: new OlCircle({
    radius: 7,
    stroke: new OlStroke({
      color: "rgba(255, 255, 255, 0.79)"
    }),
    fill: new OlFill({
      color: "rgba(26, 114, 158, 0.79)"
    })
  }),
  fill: new OlFill({
    color: "rgba(255,255,255,0.4)"
  }),
  stroke: new OlStroke({
    color: "#3399CC",
    width: 3.25
  })
});

const measuringStyle = new OlStyle({
  fill: new OlFill({
    color: 'rgba(255, 255, 255, 0.2)',
  }),
  stroke: new OlStroke({
    color: 'rgba(0, 0, 0, 0.5)',
    lineDash: [10, 10],
    width: 4,
  }),
  image: new OlCircle({
    radius: 5,
    stroke: new OlStroke({
      color: 'rgba(0, 0, 0, 0.5)',
      width: 4
    }),
    fill: new OlFill({
      color: 'rgba(255, 255, 255, 0.2)',
    }),
  })
});

// @Piero
// not sure what f is at the moment (maybe layer)
const measurementsStyle = (f: any) => {
  const geom = f.getGeometry();

  var output;
  var tooltipCoord;

  if (geom instanceof OlGeomPolygon) {
    output = formatArea(geom);
    //tooltipCoord = geom.getInteriorPoint().getCoordinates();
    tooltipCoord = geom.getCoordinates()[0];
  } else if (geom instanceof OlGeomLineString) {
    output = formatLength(geom);
    tooltipCoord = geom.getCoordinates()[0];
  } else if (geom instanceof OlGeomPoint) {
    let htrs_array = transform(geom.getCoordinates(), "EPSG:3857", "EPSG:3765");
    output = "X: " + htrs_array[0].toFixed(0) + ", Y:" + htrs_array[1].toFixed(0);
    tooltipCoord = geom;
  }
  let style = [
    new OlStyle({
      image: new OlCircle({
        radius: 5,
        stroke: new OlStroke({
          color: "#232f34",
          width: 4
        }),
        fill: new OlFill({
          color: "rgba(255, 255, 255, 0.2)"
        })
      })
    }),
    new OlStyle({
      fill: new OlFill({
        color: "rgba(255, 255, 255, 0.5)"
      }),
      stroke: new OlStroke({
        color: "#232f34",
        lineDash: [10, 10],
        width: 4,
      })
    }),
    new OlStyle({
      text: new OlText({
        font: "12px Roboto, Arial, sans-serif",
        fill: new OlFill({ color: "#000" }),
        stroke: new OlStroke({ color: "#fff", width: 8 }),
        text: output,
        textBaseline: "middle",
        offsetY: -12
      })
    })
    // ,
    // new OlStyle({
    //   image: new OlCircle({
    //     radius: 3,
    //     stroke: new OlStroke({
    //       color: "#232f34"
    //     }),
    //     fill: new OlFill({
    //       color: "rgba(255, 255, 255, 0.2)"
    //     })
    //   }),
    //   geometry: function (feature) {
    //     // return the coordinates of the first ring of the polygon
    //     const geom = feature.getGeometry();
    //     const type = geom.getType();
    //     var coordinates = geom.getCoordinates
    //       ? type === "Polygon"
    //         ? geom.getCoordinates()[0]
    //         : geom.getCoordinates()
    //       : null;
    //     return coordinates ? new OlGeomMultiPoint(coordinates) : null;
    //   }
    // })
  ];
  return style;
};

const geoLocateStyle = new OlStyle({
  image: new OlCircle({
    radius: 6,
    fill: new OlFill({
      color: '#3399CC',
    }),
    stroke: new OlStroke({
      color: '#fff',
      width: 2,
    })
  })
});

const drawingRouteStyle = (f: any) => {

  const color = "rgba(255, 0, 255, 0.8)";
  const fillColor = "rgba(255,0,255, 0.5)";

  const pointStyle = new OlStyle({
    image: new OlCircle({
      radius: 6,
      stroke: new OlStroke({
        color: color,
        width: 4
      })
    })
  });

  const lineStyle = new OlStyle({
    fill: new OlFill({
      color: fillColor
    }),
    stroke: new OlStroke({
      color: color,
      lineDash: [15, 15],
      width: 4
    })
  });

  const pointsOnLineStyle = new OlStyle({
    image: new OlCircle({
      radius: 6,
      stroke: new OlStroke({
        color: color,
        width: 4
      })
    }),
    geometry: function (feature) {
      // return the coordinates of the first ring of the polygon
      const geom = feature.getGeometry();
      if (geom && geom instanceof OlGeomLineString) {
        const coordinates = geom.getCoordinates();
        // coordinates.shift(); //remove first
        // coordinates.pop(); //remove last
        return new OlGeomMultiPoint(coordinates);
      } else {
        return undefined;
      }
    }
  });

  return [pointStyle, lineStyle, pointsOnLineStyle];
};

const drawRouteStyle = (f: any) => {
  const geom = f.getGeometry();
  const coords = geom.getCoordinates();
  const p1 = coords.length > 0 ? coords[0] : null;
  const p2 = coords.length >= 2 ? coords[1] : null;

  const color = "rgba(255, 0, 255, 0.8)";
  const fillColor = "rgba(255,0,255, 0.5)";

  const pointStyle = new OlStyle({
    image: new OlCircle({
      radius: 6,
      stroke: new OlStroke({
        color: color,
        width: 4
      })
    })
  });

  const lineStyle = new OlStyle({
    fill: new OlFill({
      color: fillColor
    }),
    stroke: new OlStroke({
      color: color,
      lineDash: [15, 15],
      lineDashOffset: 15,
      width: 4
    })
  });

  const pointsOnLineStyle = new OlStyle({
    image: new OlCircle({
      radius: 6,
      stroke: new OlStroke({
        color: color,
        width: 4
      })
    }),
    geometry: function (feature) {
      // return the coordinates of the first ring of the polygon
      const geom = feature.getGeometry();
      if (geom && geom instanceof OlGeomLineString) {
        const coordinates = geom.getCoordinates();
        coordinates.shift(); //remove first
        // coordinates.pop(); //remove last
        return new OlGeomMultiPoint(coordinates);
      } else {
        return undefined;
      }
    }
  });

  const firstPointOnLineStyle = new OlStyle({
    image: new OlRegularShape({
      points: 3,
      radius: 16,
      stroke: new OlStroke({
        color: color,
        width: 4
      }),
      rotation: calcAngle(p1, p2),
      rotateWithView: true
    }),
    geometry: function (feature) {
      // return the coordinates of the first ring of the polygon
      const geom = feature.getGeometry();
      if (geom && geom instanceof OlGeomLineString) {
        const coordinates = geom.getCoordinates();
        return coordinates.length > 0 ? new OlGeomPoint(coordinates[0]) : undefined;
      } else {
        return undefined;
      }
    }
  });

  const lastPointOnLineStyle = new OlStyle({
    image: new OlCircle({
      radius: 14,
      stroke: new OlStroke({
        color: color,
        width: 4
      }),
    }),
    geometry: function (feature) {
      // return the coordinates of the first ring of the polygon
      const geom = feature.getGeometry();
      if (geom && geom instanceof OlGeomLineString) {
        const coordinates = geom.getCoordinates();
        return coordinates.length > 0 ? new OlGeomPoint(coordinates[coordinates.length - 1]) : undefined;
      } else {
        return undefined;
      }
    }
  });

  return [pointStyle, lineStyle, firstPointOnLineStyle, pointsOnLineStyle, lastPointOnLineStyle];
};

const routeStyle = (f: any, res: number) => {
  const code = f.get("code");

  const outerZoomedIn = new OlStyle({
    stroke: new OlStroke({
      color: "rgba(255,255,255,1)",
      width: 9
    })
  });
  const innerZoomedIn = new OlStyle({
    stroke: new OlStroke({
      color: "rgba0, 90, 150, 0.8)",
      width: 6
    })
  });

  const outerZoomedMiddle = new OlStyle({
    stroke: new OlStroke({
      color: "rgba(255,255,255,1)",
      width: 7.5
    })
  });
  const innerZoomedMiddle = new OlStyle({
    stroke: new OlStroke({
      color: "rgba0, 90, 150, 0.8)",
      width: 4.5
    })
  });

  const outerZoomedOut = new OlStyle({
    stroke: new OlStroke({
      color: "rgba(255,255,255,1)",
      width: 6
    })
  });
  const innerZoomedOut = new OlStyle({
    stroke: new OlStroke({
      color: "rgba(0, 90, 150, 0.8)",
      width: 3
    })
  });

  return res > 600 ? [outerZoomedIn, innerZoomedIn]
    : res > 400 ? [outerZoomedMiddle, innerZoomedMiddle]
      : [outerZoomedOut, innerZoomedOut];
};

const routePointStyle = (f: any) => {
  const color = 'rgba(0, 90, 150, 0.8)'
  return new OlStyle({
    image: new OlCircle({
      radius: 6,
      stroke: new OlStroke({
        color: color,
        width: 4
      }),
      fill: new OlFill({
        color: "rgba(255,255,255,1)"
      })
    })
  });
}

const routeDashedLineStyle = (f: any) => {
  const color = 'rgba(0, 90, 150, 0.8)'
  return new OlStyle({
    stroke: new OlStroke({
      width: 2,
      color: color,
      lineDash: [5, 5]
    })
  });
}

const originalClickPointStyle = (f: any) => {
  const color = 'rgba(0, 90, 150, 0.8)'
  return new OlStyle({
    image: new OlCircle({
      radius: 4,
      stroke: new OlStroke({
        color: color,
        width: 4
      }),
      fill: new OlFill({
        color: color,
      }),
    }), zIndex: -1
  });
}


const routePinPointStyle = (f: any) => {

  const index = f.get("clusterIndex") ?? 0;
  const size = f.get("clusterSize") ?? 1;

  let rotation = 0;

  if (size > 1) {
    const spread = Math.PI * 50 / 180;
    if (size%2 == 1) {
      rotation = spread * index + spread/2 - spread * size/2
    } else 
    {
      rotation = spread * index - spread * (size-1)/2
    }
    
  }

  return new OlStyle({
    image: new OlIcon({
      src: '../images/icons/route_pin.svg',
      height: 135,
      width: 45,
      rotation: rotation,   
      rotateWithView: false, 
      anchor: [0.5, 0.5],
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
    }),
    text: new OlText({
      font: "12px Roboto, Arial, sans-serif",
      text: String(f.get("index") + 1),
      stroke: new OlStroke({
        color: "#FFFFFF",
        width: 1
      }),
      fill: new OlFill({ color: "#FFFFFF" }),
      offsetY: -30,
      offsetX: 1,
      overflow: true,
      scale: [1.2, 1.2],
      rotation: rotation   // 👈 isto ovdje
    })
  });
};


const commentsStyle = (f: any) => {
  const geom = f.getGeometry();
  var output;
  var tooltipCoord;

  if (geom instanceof OlGeomPolygon) {
    output = formatArea(geom);
    //tooltipCoord = geom.getInteriorPoint().getCoordinates();
    tooltipCoord = geom.getCoordinates()[0];
  } else if (geom instanceof OlGeomLineString) {
    output = formatLength(geom);
    tooltipCoord = geom.getCoordinates()[0];
  } else if (geom instanceof OlGeomPoint) {
    let htrs_array = transform(geom.getCoordinates(), "EPSG:3857", "EPSG:3765");
    output = "X: " + htrs_array[0].toFixed(0) + ", Y:" + htrs_array[1].toFixed(0);
    tooltipCoord = geom;
  }
  let style = [
    new OlStyle({
      image: new OlCircle({
        radius: 5,
        stroke: new OlStroke({
          color: "#388e3c",
          width: 4
        }),
        fill: new OlFill({
          color: "rgba(255, 255, 255, 0.2)"
        })
      })
    }),
    new OlStyle({
      fill: new OlFill({
        color: "rgba(255, 255, 255, 0.5)"
      }),
      stroke: new OlStroke({
        color: "#388e3c",
        // lineDash: [10, 10],
        width: 4,
      })
    }),
    // new OlStyle({
    //   text: new OlText({
    //     font: "12px Roboto, Arial, sans-serif",
    //     fill: new OlFill({ color: "#000" }),
    //     stroke: new OlStroke({color: "#fff", width: 8}),
    //     text: output,
    //     textBaseline: "middle",
    //     offsetY: -12
    //   })
    // })

    // ,
    // new OlStyle({
    //   image: new OlCircle({
    //     radius: 3,
    //     stroke: new OlStroke({
    //       color: "#232f34"
    //     }),
    //     fill: new OlFill({
    //       color: "rgba(255, 255, 255, 0.2)"
    //     })
    //   }),
    //   geometry: function (feature) {
    //     // return the coordinates of the first ring of the polygon
    //     const geom = feature.getGeometry();
    //     const type = geom.getType();
    //     var coordinates = geom.getCoordinates
    //       ? type === "Polygon"
    //         ? geom.getCoordinates()[0]
    //         : geom.getCoordinates()
    //       : null;
    //     return coordinates ? new OlGeomMultiPoint(coordinates) : null;
    //   }
    // })
  ];
  return style;
};

const commentingStyle = new OlStyle({
  fill: new OlFill({
    color: 'rgba(255, 255, 255, 0.2)',
  }),
  stroke: new OlStroke({
    color: 'rgba(56, 142, 60, 0.5)',
    lineDash: [10, 10],
    width: 4,
  }),
  image: new OlCircle({
    radius: 5,
    stroke: new OlStroke({
      color: 'rgba(56, 142, 60, 0.5)',
      width: 4
    }),
    fill: new OlFill({
      color: 'rgba(255, 255, 255, 0.2)',
    }),
  })
});

const definePoiImage = (tip_id: number, style: 1 | 2 | 3) => {
  switch (tip_id) {
    case sifrarnici.poi_tipovi.hgss:
      return `hgss_${style}.svg`;
    case sifrarnici.poi_tipovi.planinarska_kuca:
    case sifrarnici.poi_tipovi.planinarski_dom:
      return `dom_${style}.svg`;
    case sifrarnici.poi_tipovi.planinarsko_skloniste:
      return `skloniste_${style}.svg`;
    case sifrarnici.poi_tipovi.penjaliste:
      return `penjaliste_${style}.svg`;
    case sifrarnici.poi_tipovi.opasnost:
      return `opasnost_1.svg`;
    case sifrarnici.poi_tipovi.vrh:
      return `vrh_${style}.svg`;
    case sifrarnici.poi_tipovi.vidikovac:
      return `vidikovac_${style}.svg`;
    case sifrarnici.poi_tipovi.odmoriste:
      return `odmoriste_${style}.svg`;
    case sifrarnici.poi_tipovi.polaziste:
      return `polaziste_${style}.svg`;
    case sifrarnici.poi_tipovi.kult_arheo:
      return `arheo_${style}.svg`
    case sifrarnici.poi_tipovi.kult_mlin:
      return `mlin_${style}.svg`
    case sifrarnici.poi_tipovi.kult_muzej:
      return `muzej_${style}.svg`
    case sifrarnici.poi_tipovi.kult_sakralni:
      return `sakralni_${style}.svg`
    case sifrarnici.poi_tipovi.kult_spomenik:
      return `spomenik_${style}.svg`
    case sifrarnici.poi_tipovi.kult_utvrda:
      return `utvrda_${style}.svg`
    case sifrarnici.poi_tipovi.prir_izvor:
      return `izvor_${style}.svg`
    case sifrarnici.poi_tipovi.prir_slap:
      return `slap_${style}.svg`
    case sifrarnici.poi_tipovi.prir_spilja:
      return `spilja_${style}.svg`

    default:
      return `tocka_3.svg`;
  }
}

const poiStyle = (f: any, res: number) => {
  const tip_id = f.get("poi_tip_id");
  const naziv = f.get("naziv");
  const image_url = "../images/icons/" + definePoiImage(tip_id, 1);

  const smallDotStyle = new OlStyle({
    image: new OlCircle({
      radius: 2,
      // stroke: new OlStroke({
      //   color: '#FFFFFF',
      //   width: 1
      // }),
      fill: new OlFill({
        color: '#FF0000',
      }),
    })
  })

  const bigDotStyle = new OlStyle({
    image: new OlCircle({
      radius: 3,
      stroke: new OlStroke({
        color: '#FFFFFF',
        width: 1
      }),
      fill: new OlFill({
        color: '#FF0000',
      }),
    })
  })

  const iconStyle = new OlStyle({
    image: new OlIcon({
      src: image_url,
      height: 30,
      width: 30
    })
  });

  const labelStyle = new OlStyle({
    text: new OlText({
      font: "14px Roboto, Arial, sans-serif",
      fill: new OlFill({ color: "#000" }),
      stroke: new OlStroke({ color: "#E6E6E6", width: 5 }),
      text: naziv,
      textBaseline: "middle",
      offsetY: 25
    })
  })

  const pointStyle = res > 300 ? smallDotStyle
    : res > 40 ? bigDotStyle
      : iconStyle;

  const hasLabel = res < 8;

  if (hasLabel) {
    return [pointStyle, labelStyle];
  } else {
    return pointStyle;
  }
}

const ktStyle = (f: any, res: number) => {
  if (res <= 40) {
    return new OlStyle({
      text: new OlText({
        font: "14px Roboto, Arial, sans-serif",
        fill: new OlFill({ color: "#FF0000" }),
        stroke: new OlStroke({ color: "#E6E6E6", width: 5 }),
        text: ["KT", "bold 14px Roboto"],
        textBaseline: "middle",
        offsetY: -20
      })
    });
  } else {
    return [];
  }
}

const highlightedPoiStyle = (f: any, res: number) => {
  const tip_id = f.get("poi_tip_id");
  const naziv = f.get("naziv");
  const image_url = "../images/icons/" + definePoiImage(tip_id, 2);

  const labelStyle = new OlStyle({
    text: new OlText({
      font: "14px Roboto, Arial, sans-serif",
      fill: new OlFill({ color: "#000" }),
      stroke: new OlStroke({ color: "#E6E6E6", width: 5 }),
      text: naziv,
      textBaseline: "middle",
      offsetY: 25
    })
  })

  const pointStyle = new OlStyle({
    image: new OlIcon({
      src: image_url,
      height: 30,
      width: 30
    })
  });

  const hasLabel = res < 8;

  if (hasLabel) {
    return [pointStyle, labelStyle];
  } else {
    return pointStyle;
  }
}